import React from "react";
import appConfig from "../../../config/app.config";


const staticAssetsUrl = appConfig.staticAssetsUrl;

const ContentAccountAuthorization = () => {
    return (
        <div >
            <h2 className="text-xl font-bold">5.Account Authorization</h2>
            <div>
                <p>It is mandatory to configure the authorization parameters <span className="font-bold">API key</span> to use APIs. These are global parameters which are configured for all the APIs falling under a product type.</p>
                <p>Follow the steps given below to configure the API key: </p>
                <p><span className="font-bold">Step 1:</span> Select <span className="font-bold">Account Authorization APIs</span></p>
                <img className="pic" src={staticAssetsUrl + "user_manual/Products_Dasboard.png"} />
            </div>

            <div>
                <p><span className="font-bold">Step 2:</span> On the left Panel, click on <span className="font-bold">Authentication</span></p>
                <img className="pic" src={staticAssetsUrl + "user_manual/Authentication_marketplace.png"} />
            </div>

            <div>
                <p><span className="font-bold">Step 3:</span> Enter the API key in the input box and click on "Set" to configure them</p>
                <p><span className="font-bold">Step 4:</span> You are now authorized to use the subscribed APIs. </p>
                <img className="pic" src={staticAssetsUrl + "user_manual/Authorization_marketplace.png"} />
            </div>

        </div>
    )
}

export default ContentAccountAuthorization;